import {
  InputField
} from '@vodacomsa/ns-react-components';
import styled, { css } from 'styled-components';

export const FormikInputField = styled(InputField)`
  width: 100%;
  height: 60px;
  margin-bottom: 10px;

  & > :nth-child(1) {
    background-color: var(--color-white);
    border-color: var(--color-grey-200);
    width: 100%;
    height: 60px;
    border-radius: 10px !important;
  }

  ${({ overrideHintColor }) =>
    overrideHintColor &&
    css`
      .ns-text-grey-300 {
        color: var(--333, #333) !important;
      }
    `}
`;
